





















import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import LocaleSwitch from "@/components/LocaleSwitch";
import SignUpComponent from "@/components/SignUpComponent";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "PageSignUp",
  components: { LocaleSwitch, BasePage, SignUpComponent, SiteLogo },
});
